import Create from './Create.graphql';
import Update from './Update.graphql';
import ClientsBrandList from './ClientsBrandList.graphql';
import Read from './Read.graphql';

export const UserFormCreate = Create;
export const UserFormUpdate = Update;
export const UserFormClientsBrandList = ClientsBrandList;
export const UserFormReadQuery = Read;
